import { render, staticRenderFns } from "./myOrganisationForm.vue?vue&type=template&id=a0958ad2&"
import script from "./myOrganisationForm.vue?vue&type=script&lang=js&"
export * from "./myOrganisationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports